module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/timeclock/timesheets-f41492.png";